import { schneiderNav, WhiteLabelConfig } from '@allesauto/core/whiteLabel';
import { QueryWhiteLabelConfig, SchemaTypes } from '@allesauto/graphql';
import axios from 'axios';

import { initializeApollo } from '@/global/apollo/apollo';

import { detachedWhiteLabelIntegrationSlugs } from './getWhiteLabelIntegrationSlugs';

type GetWhiteLabelConfigQuery = Pick<SchemaTypes.Query, 'getWhiteLabelConfig'>;

const isResource = (integrationSlug: string) => {
  const resourcePattern =
    /[\\/.](gif|jpg|jpeg|tiff|png|ico|json|css|css.map)$/i;

  return resourcePattern.test(integrationSlug);
};

export const getWhiteLabelConfig = async (
  integrationSlug: string | undefined
): Promise<WhiteLabelConfig | undefined> => {
  // Skip rest if we received no integration slug or is resource file
  if (
    !integrationSlug ||
    integrationSlug === 'alles.auto' ||
    isResource(integrationSlug)
  ) {
    return undefined;
  }

  // Resolve whiteLabelConfig through Apollo
  const apolloClient = initializeApollo();
  const siteConfigType = 'site-config';
  // TODO Make version configurable
  const version = 'DRAFT'; // DRAFT

  const { data, error } = await apolloClient.query<GetWhiteLabelConfigQuery>({
    query: QueryWhiteLabelConfig,
    variables: {
      integrationSlug,
      pageSlug: siteConfigType,
      version: version,
      environment: process.env.ENVIRONMENT,
      skipStoryBlok: detachedWhiteLabelIntegrationSlugs.has(integrationSlug),
    },
    errorPolicy: 'all',
  });

  if (error || !data.getWhiteLabelConfig) {
    throw new Error(
      `No matching WhiteLabelConfig for integration slug "${integrationSlug}"`
    );
  }

  return data.getWhiteLabelConfig;
};

export const getSchneiderGruppeNavigation = async (
  navigation_api_url: string
): Promise<schneiderNav | undefined> => {
  try {
    const res = await axios.get(navigation_api_url);
    return await res.data;
  } catch (error: any) {
    throw new Error(
      `No matching WhiteLabelConfig for integration slug "${error.message}"`
    );
  }
};
